import { createAction, props, State } from '@ngrx/store';

export const InitializationComplete = createAction('[Initialization] Initialization complete');
